import type { DropDownProps } from 'antd'
import { Dropdown as AntdDropdown } from 'antd'
import { DropdownButton } from './DropdownButton'

export type { DropDownProps } from 'antd'

const DropdownComponent = (props: DropDownProps) => <AntdDropdown {...props} />

export const Dropdown = Object.assign(DropdownComponent, {
  ...AntdDropdown,
  Button: DropdownButton
})
